import { FC } from 'react';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { TextInput } from '@telialt/common-text-input/src';

import { LEAD_TEST_IDS } from '../constants';
import { LeadFieldName } from '../model';

type Props = { initialValue?: string };

export const AddressField: FC<Props> = ({ initialValue = '' }) => {
    const { t } = useTranslations();

    return (
        <TextInput
            label={t['content.lead.address.label']}
            name={'address' as LeadFieldName}
            dataTest={LEAD_TEST_IDS.FIELD_ADDRESS}
            defaultValue={initialValue}
        />
    );
};
